import { Component, OnInit, Input} from '@angular/core';
import { Product, Category, Paging, CategoryResponse, Tag, CategoryItems } from '../../products/product';
import { ProductsService } from '../../products/products.service';
import { Query } from "../../products/query";
import { ConfigurationService } from "../../configuration.service";
import { Configuration } from "../../configuration";


import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { interval } from "rxjs/observable/interval";
import { map, switchMap, publish, tap, take, filter, throttle } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { takeWhile} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';


@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.scss"]
})
export class CategoryComponent implements OnInit {
  config: Configuration;
  dataLoading: boolean = true;
  // current_page:1
  // data:[]
  // first_page_url:"http://v3.pdm-plants-textures.com/api/files?page=1"
  // from:1
  // last_page:5
  // last_page_url:"http://v3.pdm-plants-textures.com/api/files?page=5"
  // next_page_url:"http://v3.pdm-plants-textures.com/api/files?page=2"
  // path:"http://v3.pdm-plants-textures.com/api/files"
  // per_page:"20"
  // prev_page_url:null
  // to:20
  // total:83

  itemData: any = {};
  index: number = 0;
  files: Product[] = [];
  fileCount: number = 0;

  emitter;
  indexer: Observable<number> = Observable.create(e => (this.emitter = e));

  @Input()
  thisCategory: Category;

  constructor(
    private productsService: ProductsService,
    private configurationService: ConfigurationService
  ) {
    this.config = configurationService.getConfigurationCache();
  }

  ngOnInit() {
    const filterQuery: Query = {
      page: 0,
      category: this.thisCategory.id,
      limit: 20
    };

    //  Listen to the index requiring update, tp form new filter
    // Bootstrap on Load
    this.indexer
      .pipe(
        // only emit if the current index is below the current file count
        takeWhile((i: number) => this.thisCategory && this.thisCategory.fileCount && this.fileCount < this.thisCategory.fileCount ),
        filter(
          (i: number) => {

            // filter out all but items divisble by 10
            return i % 10 === 0;
          }
        ), map((i: number) => {
          // increment the page filter
          filterQuery.page++;
          return filterQuery;
        }), switchMap((filterQuery: Query) =>
          this.productsService.getProducts(filterQuery)
        ) )
      .subscribe((results: any) => {

        this.dataLoading = false;
        this.itemData = results;
        // Concat the results
        Array.prototype.push.apply(this.files, results.data);
        // Update the total count
        this.fileCount = this.files.length;
      });
    // INI the call at page:1
    this.emitter.next(0);
  }

  indexChangeHandler(index) {

    // write behaviour subject, update after every 20, so will call next
    if (
      this.thisCategory.fileCount &&
      this.thisCategory.fileCount > index - 20
    ) {
      this.index = index;

      this.emitter.next(index);
    } else {
      this.emitter.complete();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home-page/category/category.component.ts